import { render, staticRenderFns } from "./DeveloperInitiators.vue?vue&type=template&id=5f7fedb6"
import script from "./DeveloperInitiators.vue?vue&type=script&lang=js"
export * from "./DeveloperInitiators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports